<bic-popup (close)="closed.emit()" [hasBackdrop]="true" customClass="w-[600px]" title="Weitere KI-Modelle">
  <div bicPopupContent class="flex flex-col items-start gap-4 text-sm">
    <div>
      Für Ihre Prüfungen steht das Modell
      <span class="font-medium">{{ currentModel }}</span>
      zur Verfügung. Es ist für die Prüfaufgaben in planBIC ausgelegt und in allen Tarifen enthalten.
    </div>
    <div>
      Weitere KI-Modelle sind Teil des <span class="font-medium">Enterprise-Angebots</span> und werden
      individuell vereinbart – zusammen mit dem passenden Kontingent. Nach der Freischaltung können Sie
      das Modell hier je Prüfregelset auswählen.
    </div>
  </div>
  <div bicPopupButtonGroup class="flex flex-row justify-end gap-4">
    <bic-button (onClick)="closed.emit()" buttonType="white">
      Schließen
    </bic-button>
    <bic-button (onClick)="offerRequested.emit()" buttonType="primary">
      Zum Angebot
    </bic-button>
  </div>
</bic-popup>
